
<div #mapContainer style="height: 100%"></div>